import './bootstrap';
import {afterComponentLoadBootstrap} from "./bootstrap";
import {initPublicTicketsIndex} from "./tickets";

const componentMap = {
    'public.tickets.index': {
        action: initPublicTicketsIndex
    },
};

document.addEventListener('DOMContentLoaded', () => {
    // Init components
    // noinspection JSUnresolvedReference
    if (window.jsComponents) {
        window.jsComponents.forEach(componentKey => {
            if (componentMap[componentKey]) {
                componentMap[componentKey].action();
            } else {
                console.error(`"${componentKey}" component not found`);
            }
        })
    }

    afterComponentLoadBootstrap()
})
